"use client";

import { CtaFlexible } from "@/components/shared/cta";
import PortableText from "@/components/shared/portable-text";
import { ResponsiveImage } from "@/components/shared/ResponsiveImage";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { cn } from "@/lib/ui/cn";

import type { TeamMemberItem } from "./shared";

type TeamCarouselModalProps = {
  item: TeamMemberItem;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  textColorClasses?: string;
};

export function TeamCarouselModal({
  item,
  isOpen,
  onOpenChange,
  textColorClasses,
}: TeamCarouselModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[90vh] max-w-4xl overflow-y-auto">
        <div className="tablet:flex-row tablet:items-start flex flex-col gap-6">
          {item.image && (
            <div className="tablet:w-[183px] tablet:h-[183px] relative aspect-square h-[124px] w-[124px] shrink-0">
              <ResponsiveImage
                src={item.image}
                fill
                className="rounded-lg object-cover"
                imageOptions={{ desktopWidth: 400 }}
              />
            </div>
          )}

          <div className="flex flex-1 flex-col gap-4">
            {item.bio && (
              <div className="flex-1">
                <PortableText
                  value={item.bio}
                  className={cn(
                    "prose prose-p:my-4 typography-text-regular-normal",
                    textColorClasses ||
                      "prose-p:text-neutral-darkest prose-strong:text-neutral-darkest prose-em:text-neutral-darkest prose-a:text-neutral-darkest",
                  )}
                />
              </div>
            )}

            {item.cta && item.cta.label && item.cta.href && (
              <div className="pt-4">
                <CtaFlexible
                  cta={{
                    ...item.cta,
                    label: item.cta.label,
                    href: item.cta.href,
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
